import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { MainFiltersForm } from '../../forms';
import MainFiltersFormOld from '../../forms/MainFiltersForm/MainFiltersFormOld';
import Video from './bikes.mp4';
import { ExperimentId, ExperimentVariant } from '../../abTest';
import { useExperiment } from '../../hooks/useExperiment.hook';

import css from './SectionHero.css';

const SectionHero = props => {
  const {
    rootClassName,
    className,
    onScroll,
    intl,
    categoriesSuggestions,
    history,
    location,
    viewport,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const countriesWithAnotherImg = ['pl', 'sk', 'hu'];
  const isAnotherImg = !!countriesWithAnotherImg.find(
    item => item === process.env.REACT_APP_COUNTRY_ID
  );

  const { Variant: SectionHeroVariant } = useExperiment({
    id: ExperimentId.SECTION_HERO,
    variants: {
      [ExperimentVariant.CONTROL]: (
        <div
          className={classNames(css.container, {
            [css.anotherImg]: isAnotherImg,
            [css.anotherImgHu]: process.env.REACT_APP_COUNTRY_ID === 'hu',
          })}
        >
          <div className={css.content}>
            <h1
              className={classNames(css.heroMainTitle, {
                [css.slovak]: process.env.REACT_APP_COUNTRY_ID === 'sk',
              })}
            >
              <FormattedMessage id="SectionHero.mainTitle" className={css.mainTtitleSpan} />
            </h1>
            {/* <TitleVariant />  */}
            {process.env.REACT_APP_COUNTRY_ID === 'sk' && (
              <h2 className={css.subtitleSpan}>
                <FormattedMessage id="SectionHero.subTitle" />
              </h2>
            )}
            <MainFiltersForm
              intl={intl}
              location={location}
              history={history}
              categoriesSuggestions={categoriesSuggestions}
              formContainerClassName={css.heroForm}
              buttonSearchClassName={css.submitButton}
              locationInputClassName={css.customSelectInput}
              locationInputFocusClassName={css.customSelectInputFocus}
              listingInputClassName={css.customSelectInput}
              listingInputFocusClassName={css.customSelectInputFocus}
              predictionsClassName={css.predictions}
              suggestionsWrapperClassName={css.suggestionsWrapper}
              locationWrapperClassName={css.locationWrapper}
              wrapperClassName={css.suggestionWrapper}
              displayProviderFilter={false}
            />
          </div>
        </div>
      ),
      [ExperimentVariant.VARIANT_A]: (
        // <div
        //   className={classNames(css.container, {
        //     [css.anotherImg]: isAnotherImg,
        //     [css.anotherImgHu]: process.env.REACT_APP_COUNTRY_ID === 'hu',
        //   })}
        // >
        //   <div className={css.content}>
        //     <h1
        //       className={classNames(css.heroMainTitle, {
        //         [css.slovak]: process.env.REACT_APP_COUNTRY_ID === 'sk',
        //       })}
        //     >
        //       <FormattedMessage id="SectionHero.mainTitle" className={css.mainTtitleSpan} />
        //     </h1>
        //     {/* <TitleVariant />  */}
        //     {process.env.REACT_APP_COUNTRY_ID === 'sk' && (
        //       <h2 className={css.subtitleSpan}>
        //         <FormattedMessage id="SectionHero.subTitle" />
        //       </h2>
        //     )}
        //     <MainFiltersForm
        //       intl={intl}
        //       location={location}
        //       history={history}
        //       categoriesSuggestions={categoriesSuggestions}
        //       formContainerClassName={css.heroForm}
        //       buttonSearchClassName={css.submitButton}
        //       locationInputClassName={css.customSelectInput}
        //       locationInputFocusClassName={css.customSelectInputFocus}
        //       listingInputClassName={css.customSelectInput}
        //       listingInputFocusClassName={css.customSelectInputFocus}
        //       predictionsClassName={css.predictions}
        //       suggestionsWrapperClassName={css.suggestionsWrapper}
        //       locationWrapperClassName={css.locationWrapper}
        //       wrapperClassName={css.suggestionWrapper}
        //       displayProviderFilter={false}
        //     />
        //   </div>
        // </div>
        <div
          className={classNames(css.container, {
            [css.testBg]: true
          })}
        >
          <div className={css.content}>
            <div className={css.weather}>
              <span>☀️</span>
              <span>Ciepły i słoneczny weekend nadchodzi!</span>
            </div>  
            <h1
              className={classNames(css.heroMainTitle, css.testH1)}
            >
              Wypożycz sprzęt sportowy!
            </h1>
            <MainFiltersForm
              intl={intl}
              location={location}
              history={history}
              categoriesSuggestions={categoriesSuggestions}
              formContainerClassName={css.heroForm}
              buttonSearchClassName={css.submitButton}
              locationInputClassName={css.customSelectInput}
              locationInputFocusClassName={css.customSelectInputFocus}
              listingInputClassName={css.customSelectInput}
              listingInputFocusClassName={css.customSelectInputFocus}
              predictionsClassName={css.predictions}
              suggestionsWrapperClassName={css.suggestionsWrapper}
              locationWrapperClassName={css.locationWrapper}
              wrapperClassName={css.suggestionWrapper}
              displayProviderFilter={false}
            />
          </div>
        </div>
      ),
    },
  });

  // return <>
  //   {SectionHeroVariant}
  // </>

  return (
    <div
      className={classNames(css.container, {
        [css.anotherImg]: isAnotherImg,
        // [css.anotherImgHu]: process.env.REACT_APP_COUNTRY_ID === 'hu',
      })}
    >
      {/* <div className={css.video}>
        <div className={classNames(css.overlay)} />
        <div className={classNames(css.img, { [css.czLanding]: isAnotherImg })} />
      </div> */}
      <div className={css.content}>
        <h1
          className={classNames(css.heroMainTitle, {
            [css.slovak]: process.env.REACT_APP_COUNTRY_ID === 'sk',
          })}
        >
          <FormattedMessage id="SectionHero.mainTitle" className={css.mainTtitleSpan} />
        </h1>
        {/* <TitleVariant />  */}
        {process.env.REACT_APP_COUNTRY_ID === 'sk' && (
          <h2 className={css.subtitleSpan}>
            <FormattedMessage id="SectionHero.subTitle" />
          </h2>
        )}
        <MainFiltersForm
          intl={intl}
          location={location}
          history={history}
          categoriesSuggestions={categoriesSuggestions}
          formContainerClassName={css.heroForm}
          buttonSearchClassName={css.submitButton}
          locationInputClassName={css.customSelectInput}
          locationInputFocusClassName={css.customSelectInputFocus}
          listingInputClassName={css.customSelectInput}
          listingInputFocusClassName={css.customSelectInputFocus}
          predictionsClassName={css.predictions}
          suggestionsWrapperClassName={css.suggestionsWrapper}
          locationWrapperClassName={css.locationWrapper}
          wrapperClassName={css.suggestionWrapper}
          displayProviderFilter={false}
        />
      </div>
    </div>
  );

  return (
    <div className={classes}>
      <div className={css.video}>
        <div className={classNames(css.overlay)} />
        <div className={classNames(css.img, { [css.czLanding]: isAnotherImg })} />
      </div>

      {/* <video autoPlay playsInline className={css.video} loop muted>
        <source src={Video} type="video/mp4" />
        <track default="" kind="captions" />
      </video> */}
      <div className={css.heroContent}>
        {/* <TitleVariant /> */}
        <h1
          className={classNames(css.heroMainTitle, {
            [css.slovak]: process.env.REACT_APP_COUNTRY_ID === 'sk',
          })}
        >
          <FormattedMessage id="SectionHero.mainTitle" className={css.mainTtitleSpan} />
        </h1>
        {process.env.REACT_APP_COUNTRY_ID === 'sk' && (
          <h2 className={css.subtitleSpan}>
            <FormattedMessage id="SectionHero.subTitle" />
          </h2>
        )}
        <MainFiltersForm
          intl={intl}
          location={location}
          history={history}
          categoriesSuggestions={categoriesSuggestions}
          formContainerClassName={css.heroForm}
          buttonSearchClassName={css.submitButton}
          locationInputClassName={css.customSelectInput}
          locationInputFocusClassName={css.customSelectInputFocus}
          listingInputClassName={css.customSelectInput}
          listingInputFocusClassName={css.customSelectInputFocus}
          predictionsClassName={css.predictions}
          suggestionsWrapperClassName={css.suggestionsWrapper}
          locationWrapperClassName={css.locationWrapper}
          wrapperClassName={css.suggestionWrapper}
        />
      </div>
    </div>
  );
};

export default SectionHero;
